import { render, staticRenderFns } from "./Auto-list.vue?vue&type=template&id=489c3f6d&"
import script from "./Auto-list.vue?vue&type=script&lang=js&"
export * from "./Auto-list.vue?vue&type=script&lang=js&"
import style0 from "./Auto-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports